import React from 'react';
import { Spin } from 'antd';
import './index.less';

const Loading = () => {
  return (
    <div className="loading-container">
      <Spin size="large" tip="加载中..." />
    </div>
  );
};

export default Loading;
